import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    background: theme.colorPalette.beige_25
  },
  btn: {
    width: '100%',
    marginTop: theme.spacing(5)
  },
  inspectionInfoContainer: {
    padding: theme.spacing(1, 4)
  },
  status: {
    borderRadius: 18,
    width: 'fit-content',
    height: 33,
    alignContent: 'space-around',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  notOrdered: {
    padding: theme.spacing(0, 4),
    border: `solid 1px ${theme.colorPalette.green_75}`
  },
  inProgress: {
    padding: theme.spacing(0, 4),
    border: `solid 1px ${theme.colorPalette.green_75}`
  },
  completed: {
    padding: theme.spacing(0, 4),
    border: 'solid 1px #87c540'
  },
  failed: {
    padding: theme.spacing(0, 4),
    border: `solid 1px ${theme.colorPalette.red_100}`
  },
  completedIcon: {
    marginRight: theme.spacing(1),
    color: '#87c540',
    width: 30,
    height: 30
  },
  inProgressIcon: {
    marginRight: theme.spacing(1),
    color: theme.colorPalette.green_75,
    width: 30,
    height: 30
  },
  failedIcon: {
    marginRight: theme.spacing(1),
    color: theme.colorPalette.red_100,
    width: 30,
    height: 30
  }
}));

export default useStyles;
